import { createFileRoute } from '@tanstack/react-router'
import UploadFilePage from '@/pages/UploadFilePage'

export const Route = createFileRoute('/$leaid/_error-wrapper/upload')({
  component: UploadFilePage,
})